/* global localData */
if (document.querySelector('#subscription-form')) {
  const subscriptionForm = (() => {
    const r = {
      signUp: document.querySelector('#subscription-form'),
      buttons: document.querySelectorAll('#subscription-form a'),
      loading: false,
      sendAjax: () => {
        r.isValid = true;
        const formData = {};
        r.signUp.querySelectorAll('input').forEach((input) => {
          const type = input.getAttribute('type');
          switch (type) {
            case 'checkbox':
              formData[input.name] = input.checked;
              if (typeof input.getAttribute('required') === 'string' && !input.checked) {
                input.closest('div').classList.add('is-validation-failed');
                r.isValid = false;
              } else {
                input.closest('div').classList.remove('is-validation-failed');
              }
              break;
            case 'email':
              formData[input.name] = input.value.trim();
              if (typeof input.getAttribute('required') === 'string') {
                if (!/^[\w\d._-]+@[\w\d\-_.]+\.[\d\w][\d\w]+$/.test(formData[input.name])) {
                  input.closest('div').classList.add('is-validation-failed');
                  r.isValid = false;
                } else {
                  input.closest('div').classList.remove('is-validation-failed');
                }
              }
              break;
            default:
          }
        });
        if (r.isValid && !r.loading) {
          const ajax = new XMLHttpRequest();
          const formInfo = new FormData();
          formInfo.append('action', 'saveEmailSubmission');
          formInfo.append('id', localData.id);
          formInfo.append('inputs', JSON.stringify(formData));
          ajax.open('POST', localData.siteURL, true);
          ajax.onload = function () {
            const response = JSON.parse(ajax.responseText);
            r.signUp.innerHTML = response.data.message;
          };
          ajax.send(formInfo);
        }
      },
      initButton: () => {
        r.buttons.forEach((item) => {
          item.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            r.sendAjax();
          });
        });
      },
    };
    return {
      initialize: () => {
        r.initButton();
      },
    };
  })();
  subscriptionForm.initialize();
}
